import { useState } from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "src/components/base/table";
import { Switch } from "src/components/base/switch"; // Oder Checkbox
import { Badge } from "src/components/base/badge";
import { Card } from "src/components/landing/shared";

// Beispiel-Daten
const initialSoftware = [
    { id: 1, name: "Google Chrome", vendor: "Google LLC", versions: 3, endpoints: 142, approved: true },
    { id: 2, name: "Zoom", vendor: "Zoom Video Communications", versions: 2, endpoints: 89, approved: false },
    { id: 3, name: "WinRAR", vendor: "win.rar GmbH", versions: 1, endpoints: 12, approved: false },
    { id: 4, name: "Visual Studio Code", vendor: "Microsoft Corp.", versions: 5, endpoints: 67, approved: true },
];

export function SoftwareInventory() {
    const [softwareList, setSoftwareList] = useState(initialSoftware);

    // Funktion zum Umschalten des Status
    const toggleApproval = (id: number) => {
        setSoftwareList((prev) => prev.map((item) => (item.id === id ? { ...item, approved: !item.approved } : item)));
    };

    return (
        <Card className="space-y-4">
            <Table className="mt-4" dense>
                <TableHead>
                    <TableRow>
                        <TableHeader>Name</TableHeader>
                        <TableHeader>Hersteller</TableHeader>
                        <TableHeader className="text-center">Versions</TableHeader>
                        <TableHeader className="text-center">Endpoints</TableHeader>
                        <TableHeader className="text-right">Approved</TableHeader>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {softwareList.map((sw) => (
                        <TableRow key={sw.id} className="transition-colors hover:bg-zinc-50 dark:hover:bg-white/5">
                            <TableCell className="font-semibold text-zinc-900 dark:text-white">{sw.name}</TableCell>
                            <TableCell className="text-zinc-600 dark:text-zinc-400">{sw.vendor}</TableCell>
                            <TableCell className="text-center">
                                <Badge color="zinc">{sw.versions}</Badge>
                            </TableCell>
                            <TableCell className="text-center font-mono text-xs">{sw.endpoints}</TableCell>
                            <TableCell className="text-right">
                                <div className="flex justify-end">
                                    <Switch
                                        checked={sw.approved}
                                        onChange={() => toggleApproval(sw.id)}
                                        color="emerald" // Nutzt Grün für "Approved"
                                    />
                                </div>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Card>
    );
}
